import { render, staticRenderFns } from "./CandidatesView.vue?vue&type=template&id=2571d002&"
import script from "./CandidatesView.vue?vue&type=script&lang=js&"
export * from "./CandidatesView.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesView.vue?vue&type=style&index=0&id=2571d002&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports